export const URL_FILES = `${HOST_API_FILES}/api/v1/file`;